<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M6.18801 21.8547C5.69187 22.2117 5 21.8571 5 21.2459V6.25C5 4.45507 6.45507 3 8.25 3H15.7484C17.5433 3 18.9984 4.45507 18.9984 6.25V21.2459C18.9984 21.8571 18.3065 22.2117 17.8104 21.8547L11.9992 17.6738L6.18801 21.8547ZM17.4984 6.25C17.4984 5.2835 16.7149 4.5 15.7484 4.5H8.25C7.2835 4.5 6.5 5.2835 6.5 6.25V19.7824L11.5612 16.141C11.8228 15.9528 12.1755 15.9528 12.4372 16.141L17.4984 19.7824V6.25Z" fill="#0F0017"/>
  </svg>
</template>
